import { useSelector } from 'react-redux';
import useFetch from './useFetch';
import AccountService from '../services/account-service';

const noop = async () => {};

function useUserOrganisations() {
  const { isLoggedIn } = useSelector(state => state.loginReducer);
  return useFetch(isLoggedIn ? AccountService.getUserOrganisations : noop).data;
}

export default useUserOrganisations;
